import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Switch from 'react-switch';
import { SwitchState, SWITCH_STATE_ICON } from 'site-modules/profile/components/shared/switch-state/switch-state';

export function EmailSubscriptionPoint({ title, id, onChange, isChecked, className = null, isEditMode }) {
  const uncheckedIcon = <SwitchState title="no" position="right" classname="pe-0_5" />;
  const checkedIcon = <SwitchState title="yes" position="left" classname="ps-0_5" />;

  return (
    <Row className={classnames(className)}>
      <Col xs={8}>{title}</Col>
      <Col xs={4} className="text-end text-md-start">
        {isEditMode && (
          <Switch
            id={id}
            name={id}
            checked={isChecked}
            onChange={onChange}
            onColor="#0069bf"
            offColor="#767676"
            className="alert-toggle"
            uncheckedIcon={uncheckedIcon}
            checkedIcon={checkedIcon}
            handleDiameter={20}
            height={24}
            width={68}
          />
        )}
        {!isEditMode && SWITCH_STATE_ICON[isChecked]}
      </Col>
    </Row>
  );
}

EmailSubscriptionPoint.propTypes = {
  id: PropTypes.string.isRequired,
  isEditMode: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  className: PropTypes.string,
};
